import { css } from "@emotion/css"

import Image from "@p-ban/common/src/components/html/Image"
import useBool from "@p-ban/common/src/hooks/useBool"

import usePageTransitionEffect from "../../../../routes/usePageTransitionEffect"
import TextInput from "../input/TextInput"

import hideIcon from "./hide.svg"
import showIcon from "./show.svg"

type Props = Omit<React.ComponentProps<typeof TextInput>, "type"> & {
  inputWidth?: number
}

const Password = ({ inputWidth, autoComplete: passwordAutoComplete, ...props }: Props) => {
  const [shouldRevealPassword, , hide, toggle] = useBool(false)

  // パスワード表示状態で画面遷移が発生すると、パスワードマネージャーがパスワードを認識できずパスワード保存ダイアログが表示されません。
  // https://web.dev/i18n/ja/sign-in-form-best-practices/#submission
  // そのため画面遷移時に強制的にパスワードを非表示にしてます。
  usePageTransitionEffect(hide)

  const type = shouldRevealPassword ? "text" : "password"
  const autoComplete = shouldRevealPassword ? "off" : passwordAutoComplete
  const src = shouldRevealPassword ? showIcon : hideIcon

  return (
    <div style={{ width: inputWidth }} className={styles.container}>
      <TextInput type={type} {...props} autoComplete={autoComplete} paddingRight={35} />
      <Image src={src} alt="" className={styles.icon} onClick={toggle} role="presentation" />
    </div>
  )
}

export default Password

const styles = {
  container: css`
    position: relative;
  `,
  icon: css`
    position: absolute;
    top: 3px;
    right: 8px;
    cursor: pointer;
    &:hover {
      opacity: 0.7;
    }
  `,
}
